<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 mt-3">
      <div class="modal-description text-center" [innerHTML]="safeMessage"></div>
      <div class="mt-3 mb-2 w-100" *ngIf="confirmationMessageRequired">
        <label for="confirmationMessage">
          Please enter the reason below:
        </label>
        <input name="confirmationMessage" id="confirmationMessage" type="text"  class="w-100" [(ngModel)]="confirmationMessage">
      </div>
      <div class="mt-3 w-100" *ngIf="isConfirmCheckbox">
        <label for="isConfirmCheckboxValue"><input id="isConfirmCheckboxValue" name="isConfirmCheckboxValue" type="checkbox" [(ngModel)]="isConfirmCheckboxValue">
          {{isConfirmCheckBoxLabel}}
        </label>
      </div>
      <div class="modal-buttons text-center">
        <button
          type="button"
          class="btn btn-default delete-button"
          (click)="closeModal('confirmed')"
        >
          {{ confirmButtonMessage || 'Delete' }}
        </button>
        <button
          type="button"
          class="btn btn-light cancel-button"
          (click)="closeModal('cancel')">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
